const content = {
  component: 'PageTypeA',
  cssClass: 'page-three',
  meta: {
    title: 'Automate Today for a Greener Tomorrow',
    description: 'For organic pesticide producer MBI, automation technology is enabling a greener tomorrow.',
    og: {
      type: 'website',
      title: 'Automate for a greener future—read more',
      description: `Through migrating ERP to cloud, the business has been able to automate key processes, helping them scale at 
        speed and take their green products to even more customers.`,
      image: require('../../assets/images/social/og_page3.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Learn how today’s automation technology is enabling a greener tomorrow.',
      description: `How can businesses change the world while scaling effectively? MBI—a producer of organic pesticides—found the 
        answer in cloud. Learn how, through automation, MBI could rapidly expand their operations.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page3.jpg')
    }
  },
  title: 'Automate Today for a Greener Tomorrow',
  heroImage: {
    preload: require('../../assets/images/backgrounds/page-three-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/page-three.jpg')
  },
  sections: [
    { 
      component: 'SectionQuote', 
      content: {
        quote: `I‘ve zero interest in becoming an expert in ERP. What I want to do is help Marrone Bio become a big, high-growth, global company`,
        author: `Jim Boyd`,
        position: `CFO, MBI`,
        type: 'quote'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          The growing interest in chemical-free food production has driven strong demand for Marrone Bio Innovations (MBI) natural, organic pesticides. Organic pesticides are derived entirely from fermented microbes and plant extracts that can target and control pests without harming the environment, people or other species.          
        `,
        type: 'intro'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: null
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          If there’s a downside to strong growth, however, it’s the strain put on existing resources. MBI has 100 employees, including CFO Jim Boyd and he would much rather spend money scaling the business than hiring additional finance staff—or a large IT department running corporate finance.
        `, 
        type: 'default'
      }
    },
    { 
      component: 'SectionImage', 
      content: {
        image: require('../../assets/images/content/page-three-a.png'),
        alt: '',
        type: 'image'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>The company discovers new products by identifying plants and microbes found in rainforests, compost piles, and flower gardens, extracting or fermenting and then manufacturing them at a scale that makes them commercially competitive with conventional chemicals.</p>
          <p>But while Marrone Bio is experiencing growth well above industry averages, scaling becomes challenging partly because it uses spreadsheets and on-premises accounting software to track manufacturing at its Michigan plant and from third-party contractors as well as to fill orders and sales from its distributor customers.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>As MBI growth accelerates, increasingly it needs automated tools to manage and track its operating expenses and human resources from the time its scientists go out into the rainforests all the way to the time when it is able to turn fermented plant extracts into marketable products for farmers.</p>
          <p>“Efficient operations throughout the organisation is critical to demonstrating an ROI to shareholders and directly impacts our ability to raise capital in the future. We can’t afford to spend days and weeks manually entering data. We need to focus 100% of our energy on innovating our industry with disruptive biologicals as fast as we can,” says Boyd.</p>
          <p>Time-to-market is particularly acute in agriculture, where missing a shipping deadline can result in lost sales forever.  Farmers need the products when the insect pests and mildews occur in the season and if the relevant product is not locally available, the farmers use the competitive offering.</p>
        `,
        type: 'default',
        backgroundImage: require('../../assets/images/backgrounds/page-three-sub-one.jpg')
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: require('../../assets/images/svg/people.svg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>If Marrone Bio had continued running on spreadsheets, “I would have had to hire up to three more people—just to manage our current output,” says Boyd.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>To Marrone Bio, the cloud is more than a tool that helps automate procurement, manufacturing, supply chain, HR and financials functions, “it’s what we are going to build our company on,” says Boyd. As a small company, “the economics of the cloud are a no-brainer. I honestly don’t think we could grow as fast as we plan to without a cloud-based ERP system to manage our critical business functions.”</p>
          <p>Oracle ERP Financials Cloud allows Boyd’s staff to enter financial data into the app only once. After that, they can share records immediately with other departments as well as employees globally.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionCallToAction', 
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          { 
            image: require('../../assets/images/svg/coins.svg'),
            copy: 'How does your finance compare to others?',
            url: 'https://valuenavigator.oracle.com/resources/VNAssessment/index.html?root=assmntQns&assmnt=AT00000001&source=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_FI_CB_SS_CM_UK_C18_Q24&intcmp=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_FI_CB_SS_CM_UK_C18_Q24',
            buttonCopy: 'Start your self-assessment'
          },
          { 
            image: require('../../assets/images/svg/person.svg'),
            copy: 'Discover why controllers choose a modern financial cloud',
            url: 'https://go.oracle.com/LP=43623?qt=saas_erp_fin_DiscovertheTopReasonsControllersChooseaModernFinancialsCloud&src1=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_FI_CT_QT_CM_UK_C18_Q24&intcmp=WWMK161025P00088:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_FI_CT_QT_CM_UK_C18_Q24',
            buttonCopy: 'Take our Quick Tour'
          }
        ],
        type: 'cta'
      }
    }
  ]
}

export default content;